import { SUPABASE_ANON_KEY, SUPABASE_URL } from "../constants/enviroment";
import { createClient } from "@supabase/supabase-js";
import { fetchWithRetry } from "../utils/fetchWithRetry";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  global: {
    fetch: fetchWithRetry,
  },
});
